import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UIService } from '@services';
import { RemoteServiceOverlayTypeEnum } from '../../../installation-overlay.model';

@Component({
  selector: 'app-internal-hydraulic-volume-flow-explanation',
  templateUrl: './internal-hydraulic-volume-flow-explanation.component.html',
  styleUrls: ['./internal-hydraulic-volume-flow-explanation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalHydraulicVolumeFlowExplanationComponent {
  @Input() installationId: number;
  @Input() gatewaySerial: string;

  constructor(private uiService: UIService) {}

  openRemoteInspectionOverlay(): void {
    this.uiService.openRemoteServiceOverlay(
      RemoteServiceOverlayTypeEnum.Diagnosis,
      this.installationId,
      this.gatewaySerial
    );
  }
}
